(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('dataLoadedInterceptor', dataLoadedInterceptor);

    dataLoadedInterceptor.$inject = ['$q', 'OltData'];

    function dataLoadedInterceptor($q, OltData) {
        var service = {
            request: request,
            requestError: requestError,
            response: response,
            responseError: responseError
        };

        return service;

        function request(config) {
            var method = config.method;
            if (method == 'GET') {
                OltData.dataLoaded = false;
            }
            return config;
        }

        function requestError(rejection) {
            var method = rejection.config.method;
            if (method == 'GET') {
                OltData.dataLoaded = false;
            }
            return $q.reject(rejection);
        }

        function response(response) {
            var method = response.config.method;
            if (method == 'GET') {
                OltData.dataLoaded = true;
            }
            return response;
        }

        function responseError(rejection) {
            var method = rejection.config.method;
            if (method == 'GET') {
                OltData.dataLoaded = false;
            }
            return $q.reject(rejection);
        }
    }
})();